import { PdfInfo } from "../Models/Pdf/PdfInfo";
import {EReportType} from "../Models/Pdf/ReportType";
import { AjaxService } from "../Helpers/AjaxService"
import { NewestPdf } from "../Models/Pdf/NewestPdf";
export class PdfApi {
    private static instance: PdfApi;
    static getInstance() { return PdfApi.instance || (PdfApi.instance = new PdfApi()); }

    getPdfsByType(reportType: EReportType) {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/pdf/GetReportsByType?reportType=${EReportType[reportType]}`;
        return new Promise<PdfInfo[]>((resolve) => {
            ajaxService.get(apiUrl,
                (result: PdfInfo[]) => {
                    result.forEach(pdfInfo => {
                        if (pdfInfo.PrintDate)
                            pdfInfo.PrintDate = this.getDateString(new Date(parseInt(pdfInfo.PrintDate.substr(6))));
                        if (pdfInfo.ReceivedDate)
                            pdfInfo.ReceivedDate = this.getDateString(new Date(parseInt(pdfInfo.ReceivedDate.substr(6))));
                        if (pdfInfo.DateAndTime) 
                            pdfInfo.DateAndTime = new Date(parseInt(pdfInfo.DateAndTime.toString().substr(6)));
                    });
                    resolve(result);
                });
        });
    }
    getContractConditions() {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/pdf/GetContractConditions`;
        return new Promise<PdfInfo[]>((resolve) => {
            ajaxService.get(apiUrl,
                (result: PdfInfo[]) => {
                    result.forEach(pdfInfo => {
                        if (pdfInfo.PrintDate)
                            pdfInfo.PrintDate = this.getDateString(new Date(parseInt(pdfInfo.PrintDate.substr(6))));
                        if (pdfInfo.ReceivedDate)
                            pdfInfo.ReceivedDate = this.getDateString(new Date(parseInt(pdfInfo.ReceivedDate.substr(6))));
                        if (pdfInfo.DateAndTime)
                            pdfInfo.DateAndTime = new Date(parseInt(pdfInfo.DateAndTime.toString().substr(6)));
                    });
                    resolve(result);
                });
        });
    }
    getNewestPdfs() {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/pdf/GetNewestPdfs`;
        return new Promise<NewestPdf[]>((resolve) => {
            ajaxService.get(apiUrl,
                (result: NewestPdf[]) => {
                    result.forEach(pdfInfo => {
                        if (pdfInfo.DateAndTime)
                            pdfInfo.DateAndTime = new Date(pdfInfo.DateAndTime);
                    });
                    resolve(result);
                });
        });
    }

    downloadFile(entryNo: number, fileName: string, company: string) {
        if (!fileName.endsWith(".pdf")) {
            fileName = fileName + ".pdf";
        }
        window.open(`/api/pdf/DownloadFile?entryNo=${entryNo}&company=${company}&filename=${fileName}`);
    }

    private getDateString(date: Date): any {
        let mm = ("0" + (date.getMonth() + 1)).slice(-2);
        let dd = ("0" + date.getDate()).slice(-2);
        let yyyy = date.getFullYear();

        if (yyyy > 1900)
            return `${dd}-${mm}-${yyyy}`;
        else
            return "";
    }
}